// extracted by mini-css-extract-plugin
module.exports = {"wrap":"cc-z","title":"dc-z","cta":"ec-z","disabled":"fc-z"};